import SearchForm from './SearchForm'

export default SearchForm
// eslint-disable-next-line import/export
export * from './SearchForm'
